import type { FC } from 'react';
import {
  Grid,
  Card,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@material-ui/core';
import { ResponsiveContainer, Pie, PieChart, Cell } from 'recharts';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderSum from 'src/components/global/TableCellHeaderSum';
import { numberToMillons } from 'src/utils/functions';
import Title from 'src/components/admin/Title';
import { STATE_RECHAZADO_RRHH } from '../../../utils/constants';

const KpiRemesaPie: FC<{ content: any[] }> = ({ content }) => {
  const COLORS = ['#4a7bb5', '#b84c49'];
  const titleFuvexPie = 'Avance en remesa por Estados , En MM de PEN';
  const totalApro = content.reduce(
    (acc, cur) => acc + (cur.estado !== STATE_RECHAZADO_RRHH ? cur.facturacion : 0),
    0,
  );
  const totalRec = content.reduce(
    (acc, cur) => acc + (cur.estado === STATE_RECHAZADO_RRHH ? cur.facturacion : 0),
    0,
  );

  const dataPie = [{ facturacion: totalApro }, { facturacion: totalRec }];
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text
        x={x}
        y={y}
        fill={COLORS[index]}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{ fontSize: '11px', fontWeight: 'bold' }}
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  return (
    <>
      <Title title={titleFuvexPie} />
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <ResponsiveContainer aspect={1}>
            <PieChart>
              <Pie
                data={dataPie}
                dataKey="facturacion"
                label={renderCustomizedLabel}
                cx="50%"
                cy="50%"
                isAnimationActive={false}
              >
                {dataPie.map((entry, index) => {
                  const key = `cell-${index}`;
                  return (
                    <Cell key={key} fill={COLORS[index % COLORS.length]} />
                  );
                })}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card>
            <Scrollbar>
              <Table size="small" className="zoomin">
                <TableHead>
                  <TableRow>
                    <TableCellHeaderSum style={{ border: 0 }}>
                      Estado
                    </TableCellHeaderSum>
                    <TableCellHeaderSum style={{ border: 0 }} align="right">
                      N° Op.
                    </TableCellHeaderSum>
                    <TableCellHeaderSum style={{ border: 0 }} align="right">
                      Monto
                    </TableCellHeaderSum>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {content.map((item, index) => {
                    const key = `detail-state-${index}`;
                    return (
                      <TableRow key={key}>
                        <TableCell>{item.estado}</TableCell>
                        <TableCell align="right">{item.operaciones}</TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacion)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Scrollbar>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiRemesaPie;
